import { Document, Packer, Paragraph, AlignmentType, HeadingLevel, ImageRun, TextRun } from 'docx';
import { saveAs } from 'file-saver';
import moment from 'moment';
import Logo from "../../../../styles/img/CompliNYC-Logo.png";

export const generateAffidavitDocument = async (clientData, buildingData) => {
  if (!clientData || !buildingData) {
    throw new Error("Client and building data are required");
  }

  // Create document
  const doc = new Document({
    sections: [
      {
        properties: {},
        children: [
          // Logo and company info header
          new Paragraph({
            alignment: AlignmentType.CENTER,
            children: [
              new ImageRun({
                data: await fetch(Logo).then((res) => res.arrayBuffer()),
                transformation: { width: 340, height: 80 },
              }),
            ],
          }),

          // Company address
          new Paragraph({
            alignment: AlignmentType.CENTER,
            children: [
              new TextRun({
                text: "35 E. Grassy Sprain Road, Suite 302, Yonkers, New York 10710, Phone: 845-366-3431",
                size: 18, // 9pt
              }),
            ],
            spacing: { after: 240 },
          }),

          // Document title
          new Paragraph({
            text: "AFFIDAVIT OF MAILING",
            heading: HeadingLevel.HEADING_1,
            alignment: AlignmentType.CENTER,
            bold: true,
            spacing: { after: 240 },
          }),

          // Property address
          new Paragraph({
            alignment: AlignmentType.CENTER,
            children: [
              new TextRun({
                text: "Property Address: ",
                bold: true,
              }),
              new TextRun({
                text:
                  buildingData.address +
                  ", " +
                  buildingData.city +
                  ", " +
                  buildingData.state +
                  " " +
                  buildingData.zip_code,
              }),
            ],
            spacing: { after: 120 },
          }),

          // Agent/Owner info
          new Paragraph({
            alignment: AlignmentType.CENTER,
            children: [
              new TextRun({
                text: "Agent/Owner - ",
                bold: true,
              }),
              new TextRun({
                text: `${clientData.user.name}, ${
                  clientData.address +
                  ", " +
                  clientData?.city || "" +
                  ", " +
                  clientData?.state || "" +
                  " " +
                  clientData?.zip_code || ""
                }`,
              }),
            ],
            spacing: { after: 240 },
          }),

          // Affidavit body - first paragraph
          new Paragraph({
            children: [
              new TextRun({
                text: "I, ________________________being duly sworn deposes and says under penalties",
              }),
            ],
            spacing: { after: 120 },
          }),

          // Of perjury line
          new Paragraph({
            text: "Of perjury:",
            spacing: { after: 240 },
          }),

          // Employment paragraph
          new Paragraph({
            children: [
              new TextRun({
                text: "I am currently employed by ",
              }),
              new TextRun({
                text: "CompliNYC",
                bold: true,
              }),
              new TextRun({
                text: " which has been retained by ",
              }),
              new TextRun({
                text: buildingData.building_corporation,
                bold: true,
              }),
              new TextRun({
                text: " to file certain annual notices on behalf of the above referenced property agent.",
              }),
            ],
            spacing: { after: 240 },
          }),

          // Mailing paragraph
          new Paragraph({
            children: [
              new TextRun({
                text: "On, __________________ I deposited in a post office box located in New York City, a properly stamped and sealed envelope in an official depository under the exclusive care and custody of the U.S. Postal Service within New York State addressed to the property referenced above to be delivered to the occupant of each of the apartments at the addresses listed in the attached.",
              }),
            ],
            spacing: { after: 240 },
          }),

          // Signature line
          new Paragraph({
            children: [
              new TextRun({
                text: "Signed: _________________________",
              }),
            ],
            spacing: { after: 240 },
          }),

          // Sworn statement
          new Paragraph({
            children: [
              new TextRun({
                text: "Sworn to before me this _______day",
              }),
            ],
            spacing: { after: 120 },
          }),

          // Date line
          new Paragraph({
            children: [
              new TextRun({
                text: "Of _______________________, 202___",
              }),
            ],
            spacing: { after: 240 },
          }),

          // Notary line
          new Paragraph({
            children: [
              new TextRun({
                text: "Notary Public",
              }),
            ],
          }),
        ],
      },
    ],
  });

  // Generate document
  const blob = await Packer.toBlob(doc);
  saveAs(blob, `Affidavit_of_Mailing_${buildingData.address.replace(/,|\s/g, '_')}.docx`);
};
